

export const getIndexMetaData = (
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.tnt.getIndexMetaData(
      actionType,
      
    )
}

export const getTNTEvents = (
  indexID: number,
  startTS: number,
  endTS: number,
  dataArray: string[],
  limit: number,
  asc: boolean,
  timeout: number,
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.tnt.getTNTEvents(
      indexID,
      startTS,
      endTS,
      dataArray,
      limit,
      asc,
      timeout,
      actionType,
      
    )
}

export const getTNTEventsScrolling = (
  indexID: number,
  startTS: number,
  endTS: number,
  startUid: number,
  dataArray: string[],
  limit: number,
  asc: boolean,
  timeout: number,
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.tnt.getTNTEventsScrolling(
      indexID,
      startTS,
      endTS,
      startUid,
      dataArray,
      limit,
      asc,
      timeout,
      actionType,
      
    )
}

export const getTNTEventsByID = (
  ts: number,
  id: string,
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.tnt.getTNTEventsByID(
      ts,
      id,
      actionType,
      
    )
}

export const loadFullTNTEvent = (
  event: any,
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.tnt.loadFullTNTEvent(
      event,
      actionType,
      
    )
}

export const listCounters = (
  tsStart: number,
  tsEnd: number,
  indexId: number,
  data: string[],
  limit: number,
  showIdCount: boolean,
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.tnt.listCounters(
      tsStart,
      tsEnd,
      indexId,
      data,
      limit,
      showIdCount,
      actionType,
      
    )
}

export const listStockTimes = (
  tsStart: number,
  tsEnd: number,
  indexId: number,
  data: string[],
  limit: number,
  showIdCount: boolean,
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.tnt.listStockTimes(
      tsStart,
      tsEnd,
      indexId,
      data,
      limit,
      showIdCount,
      actionType,
      
    )
}

export const listCountersMulti = (
  tsStart: number,
  tsEnd: number,
  indexId: number,
  data: string[][],
  limit: number,
  showIdCount: boolean,
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.tnt.listCountersMulti(
      tsStart,
      tsEnd,
      indexId,
      data,
      limit,
      showIdCount,
      actionType,
      
    )
}

export const listStockTimesMulti = (
  tsStart: number,
  tsEnd: number,
  indexId: number,
  data: string[][],
  limit: number,
  showIdCount: boolean,
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.tnt.listStockTimesMulti(
      tsStart,
      tsEnd,
      indexId,
      data,
      limit,
      showIdCount,
      actionType,
      
    )
}

export const loadChildren = (
  ts: number,
  id: string,
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.tnt.loadChildren(
      ts,
      id,
      actionType,
      
    )
}

export const loadChildrenMulti = (
  ts: number,
  ids: string[],
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.tnt.loadChildrenMulti(
      ts,
      ids,
      actionType,
      
    )
}

export const loadParentsAndChildren = (
  ts: number,
  id: string,
  actionType: string,
  
) => {
    window.parent.primingcloudRedux.tnt.loadParentsAndChildren(
      ts,
      id,
      actionType,
      
    )
}